export default __webpack_public_path__ + "static/media/Trash.533f800f.svg";